import { Box, Grid } from '@mui/material';
import FormView from '../../../../components/views/formView';
import { useSubtypeDPForm } from './hook';
import { SuptypeDPData } from './data';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    SUBTYPE_DP,
    SUBTYPE_DP_DETAIL,
    SUBTYPE_DP_EDIT,
    SUBTYPE_DP_NEW,
} from '../../../../../routes/paths';
import { SubtypeDPParamsHistorical } from '../historical';

export const SubtypeDPForm = () => {
    const {
        subtypeDP,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikSubtypeDPData,
        subtypeDPHistorical,
        showHistorical,
        setShowHistorical,
    } = useSubtypeDPForm();

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <FormView
                title={
                    subtypeDP && subtypeDP.id
                        ? 'Editar subtipo DP'
                        : 'Crear subtipo DP'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={subtypeDP?.id || ''}
                        buttonCreate={{
                            show: Boolean(subtypeDP?.id),
                            route: SUBTYPE_DP_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: SUBTYPE_DP,
                        }}
                        buttonUpdate={{
                            show: true,
                            route: SUBTYPE_DP_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: SUBTYPE_DP_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(subtypeDP?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <SubtypeDPParamsHistorical
                        historical={subtypeDPHistorical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <SuptypeDPData
                data={subtypeDP}
                onChangeFormik={(formik) => setFormikSubtypeDPData(formik)}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
